import { store, entityStore, storeActions } from '~/utility/BinSentry-ui-utility';
import { html, LitEntity, renderIf } from '../utility/lit-entity';
import { BnModalMixin } from '../common/bn-modal-mixin';
import '../common/bn-flash';
import './actions/create-import-action';
import './parts/import-csv-upload';
import './parts/import-csv-upload-button';

class AddNewImportModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'add-new-import-modal';
  }

  static get properties() {
    return {
      file: { type: Object, attribute: false },
      creating: { type: Boolean, attribute: false },
      importId: { type: String, attribute: false },
      importShowPath: { type: String, attribute: 'import-show-path' }, // e.g. /bin-imports/show
    };
  }

  renderContents() {
    return html`
      <style>
        bn-modal#add-new-import-modal {
          --modal-min-width: 55%;
        }
        bn-modal#add-new-import-modal .selected-file-label {
          margin-left: 1em;
        }
        bn-modal#add-new-import-modal .info-text {
          margin-left: 0.5em;
        }
        bn-modal#add-new-import-modal .hidden {
          display: none;
        }
        bn-modal#add-new-import-modal .right-align {
          display: flex;
          justify-content: end;
        }
      </style>
      <h3 slot="title">Create New Import</h3>
      ${this._renderAction()}
    `;
  }

  _renderAction() {
    if (!this.entity) {
      return html``;
    }

    const action = this.entity.getActionByName('create-import');
    if (!action) {
      return html``;
    }

    return html`
      <p class="info-text">Select CSV file and create import</p>
      <div class="right-align ${this.creating ? 'hidden' : ''}">
        <import-csv-upload-button
          .href="${this.href}"
          @file-selected="${(e) => this.file = e.detail.file}"
          @upload-state="${this._onUploadState}"
        >Select CSV File</import-csv-upload-button>
        ${renderIf(this.file, () => html`
          <label class="selected-file-label">Selected file:</label>
          <span>${this.file.name}</span>
        `)}
      </div>

      ${renderIf(this.file, () => html`
        <bn-surface>
          <bn-flash></bn-flash>
          ${renderIf(!this.creating, () => html`
            <create-import-action
              .href="${this.href}"
              filename="${this.file.name}"
              @submit="${this._onCreateImportSubmit}"
              @response="${this._onCreateImportResponse}"
              @error="${this._onCreateImportError}"
            ></create-import-action>
          `)}
          ${renderIf(this.creating, () => html`
              <import-csv-upload
                .href="${this.importId}"
                @upload-complete="${this._onUploadComplete}"
                @upload-error="${this._onUploadError}"
              ></import-csv-upload>
          `)}
        </bn-surface>
      `)}
    `;
  }

  _onCreateImportSubmit() {
    this.closeDisabled = true;
    const flash = this.renderRoot.querySelector('bn-flash');
    flash.clear();
    this.creating = true;
  }

  async _onCreateImportResponse(e) {
    const flash = this.renderRoot.querySelector('bn-flash');
    flash.success(html`New import created`);

    this.importId = e.detail.response.headers.get('Location');

    await entityStore.fetchWait(this.importId); // makes sure import entity is loaded for import-csv-upload
    const csvUpload = this.renderRoot.querySelector('import-csv-upload');
    return csvUpload.uploadCsv(this.file);
  }

  _onCreateImportError(e) {
    this.closeDisabled = false;
    const { error } = e;
    const flash = this.renderRoot.querySelector('bn-flash');
    flash.critical(html`Failed to create import. <pre>${error}</pre>`);
    this.creating = false;
  }

  _onUploadComplete() {
    this.closeDisabled = false;
    const flash = this.renderRoot.querySelector('bn-flash');
    flash.success('CSV file uploaded');

    setTimeout(() => {
      store.dispatch(storeActions.navigate(this.importShowPath, { importId: this.importId }));
      this.close();
    }, 1000);
  }

  _onUploadError(e) {
    this.closeDisabled = false;
    const flash = this.renderRoot.querySelector('bn-flash');
    flash.critical(html`Failed to upload file. <pre>${e.error}</pre>`);
  }

  close() {
    if (this.closeDisabled) {
      return;
    }
    this.file = undefined;
    this.importId = undefined;
    this.creating = undefined;
    super.close();
  }
}

window.customElements.define('add-new-import-modal', AddNewImportModal);
